<button class="btn source_i_btn">
    <i class="material-icons pointer" title="{{ 'CONSTANTS.ORGANIZATION_SETTINGS' | translate }}">key</i>
</button>